import { Injectable } from '@angular/core';
import { AndromedaMenuItem } from '@ansys-internal/awf-angular/contributions';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { DialogService } from '@ansys-internal/awf-angular/shared';
import { PopoutService } from '@ansys-internal/awc-angular/popouts';
import { AWFMenuItem } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';

@AWFMenuItem({
  id: ContributionsEnum.USER_PROFILE_MENU_HELP_MENU_ITEM,
  priority: 100,
})
export class HelpMenu implements AndromedaMenuItem {
  priority = 100;
  id = ContributionsEnum.USER_PROFILE_MENU_HELP_MENU_ITEM;
  type = ContributionsEnum.USER_PROFILE_MENU_HELP_MENU_ITEM;
  prefixIcon = {
    icon: Icons.HELP,
  };
  text = 'Help';
  url: string =
    'https://ansyshelp.ansys.com/account/secured?returnurl=/Views/Secured/prod_page.html?pn=ConceptEV&pid=ConceptEV';

  execute(): Promise<void> {
    return new Promise<void>((resolve) => {
      window.open(this.url, '_blank');
      resolve();
    });
  }
}
